import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useScreenSize } from '@composables/useScreenSize';

export const useAuthStore = defineStore('auth', () => {
  const bearer = ref('');
  const apikey = ref('');
  const channelKey = ref('');

  // Function to validate channel key for mobile devices (store value only)
  const validateChannelKey = (key) => {
    const { isMobile } = useScreenSize();

    // Check if device is mobile and channel key needs to be updated
    if (
      isMobile.value &&
      (!key || key === '58e5de4e971fc00be29aa10492813ad4')
    ) {
      return '974d82150b02b308a6a79ba2f87acad6';
    }

    // Return the original key if no update needed
    return key;
  };

  const setToken = (token) => {
    bearer.value = token;
  };

  const updateToken = (token) => {
    bearer.value = token;
  };

  const setApiKey = (key) => {
    apikey.value = key;
  };

  const setChannelKey = (key) => {
    // Validate and potentially update the channel key for store value
    const validatedKey = validateChannelKey(key);
    channelKey.value = validatedKey;
  };

  //action to set the api key and channel key
  const setApiKeyAndChannelKey = (key, channel) => {
    apikey.value = key;
    // Validate and potentially update the channel key for store value
    const validatedChannel = validateChannelKey(channel ?? '');
    channelKey.value = validatedChannel;
  };

  const clearToken = () => {
    bearer.value = '';
  };

  return {
    bearer,
    apikey,
    channelKey,
    setToken,
    updateToken,
    setApiKey,
    setChannelKey,
    setApiKeyAndChannelKey,
    clearToken,
  };
});
